<template>
  <div>
    <el-form :inline="true">
      <el-form-item label="域名">
        <el-input
          v-model="connectorBasic.domain"
          style="width: 350px"
        ></el-input>
      </el-form-item>
      <el-form-item label="请求地址">
        <el-input v-model="connectorBasic.url" style="width: 550px"></el-input>
      </el-form-item>
    </el-form>

    <el-input
      placeholder="请输入内容"
      :readonly="true"
      :value="`${connectorBasic.domain}${connectorBasic.url}`"
      class="input-with-select"
    >
      <el-select
        v-model="connectorBasic.method"
        slot="prepend"
        placeholder="请选择"
        style="width: 100px"
      >
        <el-option label="GET" value="GET"></el-option>
        <el-option label="POST" value="POST"></el-option>
        <el-option label="DELETE" value="DELETE"></el-option>
        <el-option label="PUT" value="PUT"></el-option>
        <el-option label="PATCH" value="PATCH"></el-option>
      </el-select>
      <el-button
        slot="append"
        icon="el-icon-search"
        @click="connector"
      ></el-button>
    </el-input>

    <el-tabs v-model="activeName" @tab-click="handleTabClick">
      <el-tab-pane label="Response" name="Response">
        <div style="margin: 10px">
          <div style="margin: 10px">
            <el-button type="primary" round @click="saveConnectorParams"
              >保存参数</el-button
            >
          </div>

          <connector-params-component
            :records="connectorParams"
            @editConnectorParam="editConnectorParam"
            @addConnectorParam="showParamDialog"
          />
        </div>
        <div style="margin: 10px">
          <json-viewer
            :value="result"
            style="border: 1px solid black"
          ></json-viewer>
        </div>
      </el-tab-pane>
      <el-tab-pane label="请求头设置" name="Header">
        <div style="padding: 10px">
          <el-button type="primary" round @click="saveConnectorParams"
            >保存参数</el-button
          >
        </div>
        <div style="margin: 10px">
          <connector-params-component
            :records="connectorParams"
            @editConnectorParam="editConnectorParam"
            @addConnectorParam="showParamDialog"
          />
        </div>
        <!-- <el-table :data="paramData" border style="width: 100%">
          <el-table-column prop="name" label="Key"> </el-table-column>
          <el-table-column prop="value" label="Value"> </el-table-column>
          <el-table-column prop="dataType" label="dataType"> </el-table-column>
          <el-table-column prop="label" label="Description"> </el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button
                type="text"
                size="small"
                @click="queryParamsById(scope.row.id)"
                >编辑</el-button
              >
              <el-button
                type="text"
                size="small"
                @click="deleteById(scope.row.id, scope.row.paramType)"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table> -->
      </el-tab-pane>
      <el-tab-pane label="Body" name="Body">
        <el-radio-group v-model="radio">
          <el-radio :label="1">json</el-radio>
          <!-- <el-radio :label="2">x-www-form-urlencoded</el-radio> -->
        </el-radio-group>

        <div style="margin-top: 10px">
          <div style="padding: 10px">
            <el-button type="primary" round @click="saveConnectorParams"
              >保存参数</el-button
            >
          </div>
          <div style="padding: 10px">
            <connector-params-component
              :records="connectorParams"
              @editConnectorParam="editConnectorParam"
              @addConnectorParam="showParamDialog"
            />
          </div>
        </div>
      </el-tab-pane>

      <el-dialog title="请求参数设置" :visible.sync="paramsDialogVisible" v-if="paramsDialogVisible" center>
        <el-form :model="paramsForm" :rules="rules" ref="ruleForm">
          <el-form-item label="参数名称" label-width="120px" prop="name">
            <el-input v-model="paramsForm.name"  autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="参数值" label-width="120px" prop="value">
            <el-input v-model="paramsForm.value" autocomplete="off"></el-input>
          </el-form-item>

          <el-form-item label="参数描述" label-width="120px" prop="label">
            <el-input v-model="paramsForm.label" autocomplete="off"></el-input>
          </el-form-item>

          <el-form-item label="数据类型" label-width="120px" prop="dataType">
            <el-select
              v-model="paramsForm.dataType"
              placeholder="请选择数据类型"
            >
              <el-option label="字符串" value="string"></el-option>
              <el-option label="日期时间" value="dataTime"></el-option>
              <el-option label="数字" value="number"></el-option>
              <el-option label="对象" value="object"></el-option>
              <el-option label="数组" value="array"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="paramsDialogVisible = false">取 消</el-button>
            <el-button type="primary" @click="addParam('ruleForm')"
              >确 定</el-button
            >
          </div>
      </el-dialog>
    </el-tabs>
  </div>
</template>

<script>
import JsonViewer from "vue-json-viewer";
import ConnectorParamsComponent from "@/components/connector/ConnectorParamsComponents";
import ConnectorApi from "@/api/ConnectorApi";
import ConnectorBasicApi from "@/api/ConnectorBasicApi";
import ConnectorParamsApi from "@/api/ConnectorParamsApi";
export default {
  components: {
    ConnectorParamsComponent,
    JsonViewer,
  },
  data() {
    return {
      paramsDialogVisible: false,
      connectorBasic: {
        method: "GET",
        domain: "http://localhost:7731",
        url: "/v2/get",
      },

      radio: 1,
      activeName: "Response",
      result: {
        msg: "get",
        code: "200",
        data: {
          userName: "13641489216",
          realName: "胡承淞",
          email: "644340980@qq.com",
        },
        state: "OK",
      },
      paramsForm: {
        name: "",
        value: "",
        label: "",
        connectorId: 2,
        dataType: "",
        paramType: 1,
      },
      paramData: [],
      bodyParamData: [],
      headerParamData: [],
      responseParamData: {},
      search: {
        pageSize: 100,
        pageNum: 1,
        connectorId: 2,
        paramType: 0,
      },
      temp: {},
      connectorParams: [],
      isEdit: false,
      node: {},
      rules: {
        name: [{ required: true, message: "请输入参数名称", trigger: "blur" }],
        value: [{ required: true, message: "请输入参数值", trigger: "blur" }],
        label: [
          { required: true, message: "请输入参数描述信息", trigger: "blur" },
        ],
        dataType: [
          { required: true, message: "请输入参数类型", trigger: "blur" },
        ],
      },
    };
  },
  async created() {
    let item = this.$route.params;
    this.search.connectorId = item.id;
    this.paramsForm.connectorId = item.id;
    await this.initData(1);
    await this.initData(2);
    await this.initData(3);
    this.queryById(item);
  },
  methods: {
    async initData(paramType) {
      this.search.paramType = paramType;
      let item = JSON.stringify(this.search);
      let resp = await  ConnectorParamsApi.search(JSON.parse(item));
      if (resp.state == "OK") {
        this.connectorParams = JSON.parse(resp.data.params);
        if (this.search.paramType == 1) {
          this.bodyParamData = JSON.parse(resp.data.params);
        }
        if (this.search.paramType == 2) {
          this.headerParamData = JSON.parse(resp.data.params);
        }
      }
    },
    queryById(id) {
      ConnectorBasicApi.queryConnectorBasicById(id).then((resp) => {
        if (resp.state == "OK") {
          this.connectorBasic = resp.data;
        }
      });
    },
    queryParamsById(id) {
      ConnectorParamsApi.queryConnectorParamsById({ id }).then((resp) => {
        if (resp.state == "OK") {
          this.paramsForm = resp.data;
          this.paramsDialogVisible = true;
        }
      });
    },
    editConnectorParam(node, params) {
      this.node = node;
      this.temp = params;
      this.isEdit = params.isEdit;
      this.paramsForm.idx = params.idx;
      this.paramsForm.name = params.name;
      this.paramsForm.label = params.label;
      this.paramsForm.dataType = params.dataType;
      this.paramsForm.value = params.value;
      this.paramsDialogVisible = true;
    },
    clearConnectorFormData() {
      this.paramsForm.idx = 0;
      this.paramsForm.name = "";
      this.paramsForm.label = "";
      this.paramsForm.dataType = "";
      this.paramsForm.value = "";
    },
    showParamDialog(params) {
      params.idx = Date.now();
      this.temp = params;
      // this.paramsForm = params
      // this.clearConnectorFormData();
      this.paramsDialogVisible = true;
    },
    addParam(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.isEdit) {
            const parent = this.node.parent;
            const children = parent.data.children || parent.data;
            const index = children.findIndex((d) => d.idx === this.temp.idx);
            let item = JSON.stringify(this.paramsForm);
            let o = JSON.parse(item);
            let sub = children[index].children || [];
            o.children = sub;
            this.$set(children, index, o);
          } else {
            this.paramsForm.idx = Date.now();
            let item = JSON.stringify(this.paramsForm);
            let o = JSON.parse(item);
            o.children = [];
            this.temp.children.push(o);
          }
          this.clearConnectorFormData();
          this.paramsDialogVisible = false;
        } else {
          return false;
        }
      });
    },

    saveConnectorParams() {
      this.$confirmDialog("确定要进行当前操作吗?", () => {
        this.paramsForm.id > 0
          ? this.updateConnectorParamsById()
          : this.addConnectorParams();
      });
    },
    addConnectorParams() {
      let content = JSON.stringify(this.connectorParams);
      let item = {
        params: content,
        paramType: this.search.paramType,
        connectorId: this.search.connectorId,
      };
      ConnectorParamsApi.saveConnectorParams(item).then((resp) => {
        if (resp.state == "OK") {
          this.$successMsg(resp.msg);
        } else {
          this.$errorMsg(resp.msg);
        }
        this.paramsDialogVisible = false;
        this.initData(this.search.paramType);
      });
    },
    updateConnectorParamsById() {
      ConnectorParamsApi.updateConnectorParams(this.paramsForm).then((resp) => {
        if (resp.state == "OK") {
          this.$successMsg(resp.msg);
        } else {
          this.$errorMsg(resp.msg);
        }
        this.paramsDialogVisible = false;
        this.initData(this.search.paramType);
      });
    },
    uniqueArray(dataArray) {
      return Array.from(new Set(dataArray.map((obj) => obj.key))).map(
        (name) => {
          return dataArray.find((obj) => obj.key === name);
        }
      );
    },
    connector() {
      this.loading = true;
      let data = {
        baseParam: {
          domain: this.connectorBasic.domain,
          url: this.connectorBasic.url,
          method: this.connectorBasic.method,
        },
        bodyParams: this.bodyParamData,
        headerParams: this.headerParamData,
      };
      ConnectorApi.connector(data).then((resp) => {
        this.result = resp;
        this.loading = false;
      });
    },
    handleTabClick(tab, event) {
      let name = tab.name;
      if (name == "Body") {
        this.search.paramType = 1;
        this.initData(1);
      } else if (name == "Header") {
        this.search.paramType = 2;
        this.initData(2);
      } else if (name == "Response") {
        this.search.paramType = 3;
        this.initData(3);
      }
    },
  },
};
</script>